"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerInstructions = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../../events");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="instructions-container">
        <div class="instructions-header">
            <h2>🚀 ${'trainer.instructions.title'.t()}</h2>
            <p>${'trainer.instructions.subtitle'.t()}</p>
        </div>

        <div class="instructions-content">
            
            <section class="instruction-section">
                <h3>📋 ${'trainer.instructions.overview'.t()}</h3>
                <p>${'trainer.instructions.overview.text'.t()}</p>
                <ol>
                    <li><strong>${'trainer.tab.upload'.t()}:</strong> ${'trainer.instructions.step.upload'.t()}</li>
                    <li><strong>${'trainer.tab.config'.t()}:</strong> ${'trainer.instructions.step.config'.t()}</li>
                    <li><strong>${'trainer.tab.training'.t()}:</strong> ${'trainer.instructions.step.monitor'.t()}</li>
                    <li><strong>${'trainer.tab.results'.t()}:</strong> ${'trainer.instructions.step.review'.t()}</li>
                </ol>
            </section>

            
            <section class="instruction-section">
                <h3>📄 ${'trainer.instructions.data.requirements'.t()}</h3>
                <div class="requirement-card">
                    <h4>${'trainer.instructions.csv.format'.t()}</h4>
                    <p>${'trainer.instructions.csv.text'.t()}</p>
                    <ul>
                        <li><code>input</code> - ${'trainer.instructions.csv.input'.t()}</li>
                        <li><code>output</code> - ${'trainer.instructions.csv.output'.t()}</li>
                        <li><code>category</code> - ${'trainer.instructions.csv.category'.t()}</li>
                    </ul>
                    
                    <div class="example-section">
                        <h5>${'trainer.instructions.example.csv'.t()}</h5>
                        <div class="code-block">
                            <button type="button" class="copy-btn" @click="${x => x.copyToClipboard(x.csvFormatExample)}">
                                📋 ${'trainer.instructions.copy'.t()}
                            </button>
                            <pre><code>${x => x.csvFormatExample}</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            
            <section class="instruction-section">
                <h3>🔄 ${'trainer.instructions.backend.format'.t()}</h3>
                <div class="requirement-card">
                    <h4>${'trainer.instructions.jsonl.format'.t()}</h4>
                    <p>${'trainer.instructions.jsonl.text'.t()}</p>
                    
                    <div class="example-section">
                        <h5>${'trainer.instructions.jsonl.example'.t()}</h5>
                        <div class="code-block">
                            <button type="button" class="copy-btn" @click="${x => x.copyToClipboard(x.dataFormatExample)}">
                                📋 ${'trainer.instructions.copy'.t()}
                            </button>
                            <pre><code>${x => x.dataFormatExample}</code></pre>
                        </div>
                    </div>
                    
                    <div class="format-notes">
                        <h5>${'trainer.instructions.format.notes'.t()}</h5>
                        <ul>
                            <li>${'trainer.instructions.format.note1'.t()}</li>
                            <li>${'trainer.instructions.format.note2'.t()}</li>
                            <li>${'trainer.instructions.format.note3'.t()}</li>
                            <li>${'trainer.instructions.format.note4'.t()}</li>
                        </ul>
                    </div>
                </div>
            </section>

            
            <section class="instruction-section">
                <h3>💡 ${'trainer.instructions.best.practices'.t()}</h3>
                <div class="tips-grid">
                    <div class="tip-card">
                        <h4>📊 ${'trainer.instructions.data.quality'.t()}</h4>
                        <ul>
                            <li>${'trainer.instructions.quality.tip1'.t()}</li>
                            <li>${'trainer.instructions.quality.tip2'.t()}</li>
                            <li>${'trainer.instructions.quality.tip3'.t()}</li>
                            <li>${'trainer.instructions.quality.tip4'.t()}</li>
                        </ul>
                    </div>
                    
                    <div class="tip-card">
                        <h4>⚙️ ${'trainer.instructions.training.config'.t()}</h4>
                        <ul>
                            <li>${'trainer.instructions.config.tip1'.t()}</li>
                            <li>${'trainer.instructions.config.tip2'.t()}</li>
                            <li>${'trainer.instructions.config.tip3'.t()}</li>
                            <li>${'trainer.instructions.config.tip4'.t()}</li>
                        </ul>
                    </div>
                    
                    <div class="tip-card">
                        <h4>🎯 ${'trainer.instructions.model.selection'.t()}</h4>
                        <ul>
                            <li>${'trainer.instructions.selection.tip1'.t()}</li>
                            <li>${'trainer.instructions.selection.tip2'.t()}</li>
                            <li>${'trainer.instructions.selection.tip3'.t()}</li>
                            <li>${'trainer.instructions.selection.tip4'.t()}</li>
                        </ul>
                    </div>
                    
                    <div class="tip-card">
                        <h4>📈 ${'trainer.instructions.monitoring'.t()}</h4>
                        <ul>
                            <li>${'trainer.instructions.monitor.tip1'.t()}</li>
                            <li>${'trainer.instructions.monitor.tip2'.t()}</li>
                            <li>${'trainer.instructions.monitor.tip3'.t()}</li>
                            <li>${'trainer.instructions.monitor.tip4'.t()}</li>
                        </ul>
                    </div>
                </div>
            </section>

            
            <section class="instruction-section">
                <h3>🔧 ${'trainer.instructions.troubleshooting'.t()}</h3>
                <div class="troubleshooting-list">
                    <details>
                        <summary>❌ ${'trainer.instructions.trouble.upload'.t()}</summary>
                        <ul>
                            <li>${'trainer.instructions.upload.fix1'.t()}</li>
                            <li>${'trainer.instructions.upload.fix2'.t()}</li>
                            <li>${'trainer.instructions.upload.fix3'.t()}</li>
                            <li>${'trainer.instructions.upload.fix4'.t()}</li>
                        </ul>
                    </details>
                    
                    <details>
                        <summary>⚠️ ${'trainer.instructions.trouble.validation'.t()}</summary>
                        <ul>
                            <li>${'trainer.instructions.validation.fix1'.t()}</li>
                            <li>${'trainer.instructions.validation.fix2'.t()}</li>
                            <li>${'trainer.instructions.validation.fix3'.t()}</li>
                            <li>${'trainer.instructions.validation.fix4'.t()}</li>
                        </ul>
                    </details>
                    
                    <details>
                        <summary>🐌 ${'trainer.instructions.trouble.slow'.t()}</summary>
                        <ul>
                            <li>${'trainer.instructions.slow.fix1'.t()}</li>
                            <li>${'trainer.instructions.slow.fix2'.t()}</li>
                            <li>${'trainer.instructions.slow.fix3'.t()}</li>
                            <li>${'trainer.instructions.slow.fix4'.t()}</li>
                        </ul>
                    </details>
                    
                    <details>
                        <summary>📉 ${'trainer.instructions.trouble.performance'.t()}</summary>
                        <ul>
                            <li>${'trainer.instructions.performance.fix1'.t()}</li>
                            <li>${'trainer.instructions.performance.fix2'.t()}</li>
                            <li>${'trainer.instructions.performance.fix3'.t()}</li>
                            <li>${'trainer.instructions.performance.fix4'.t()}</li>
                        </ul>
                    </details>
                </div>
            </section>

            
            <section class="instruction-section">
                <h3>🏁 ${'trainer.instructions.ready'.t()}</h3>
                <div class="getting-started-card">
                    <p>${'trainer.instructions.ready.text'.t()}</p>
                    <ol>
                        <li>${'trainer.instructions.ready.step1'.t()}</li>
                        <li>${'trainer.instructions.ready.step2'.t()}</li>
                        <li>${'trainer.instructions.ready.step3'.t()}</li>
                        <li>${'trainer.instructions.ready.step4'.t()}</li>
                        <li>${'trainer.instructions.ready.step5'.t()}</li>
                    </ol>
                    <p><strong>${'trainer.instructions.good.luck'.t()}</strong></p>
                </div>
            </section>
        </div>
    </div>
</template>
`;
require("./styles/layout.scss");
const styles = T.css `.instructions-container {
  padding: 2rem;
  max-width: 900px;
  margin: 0 auto;
  color: #333;
  line-height: 1.6;
}

.instructions-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 3px solid #667eea;
}
.instructions-header h2 {
  margin: 0;
  color: #667eea;
  font-size: 2rem;
  font-weight: 600;
}
.instructions-header p {
  margin: 0.5rem 0 0 0;
  color: #666;
  font-size: 1.1rem;
}

.instructions-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.instruction-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border-left: 4px solid #667eea;
}
.instruction-section h3 {
  margin: 0 0 1rem 0;
  color: #667eea;
  font-size: 1.3rem;
  font-weight: 600;
}
.instruction-section p {
  margin: 0 0 1rem 0;
  color: #555;
}
.instruction-section ol, .instruction-section ul {
  margin: 0;
  padding-left: 1.5rem;
}
.instruction-section ol li, .instruction-section ul li {
  margin-bottom: 0.5rem;
  color: #555;
}
.instruction-section ol li strong, .instruction-section ul li strong {
  color: #333;
}
.instruction-section ol li code, .instruction-section ul li code {
  background: #e9ecef;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  font-size: 0.9em;
  color: #c7254e;
}

.requirement-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.requirement-card h4 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
}
.requirement-card h5 {
  margin: 1rem 0 0.5rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.example-section {
  margin-top: 1rem;
}

.code-block {
  position: relative;
  background: #2d3748;
  border-radius: 8px;
  padding: 1rem;
  margin: 0.5rem 0;
  overflow-x: auto;
}
.code-block .copy-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.2s ease;
}
.code-block .copy-btn:hover {
  background: #2d3748;
}
.code-block pre {
  margin: 0;
  color: #e2e8f0;
  font-family: "Courier New", monospace;
  font-size: 0.9rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.code-block pre code {
  background: none;
  padding: 0;
  color: inherit;
}

.format-notes {
  margin-top: 1rem;
  padding: 1rem;
  background: #fff3cd;
  border-radius: 6px;
  border: 1px solid #ffeaa7;
}
.format-notes h5 {
  margin: 0 0 0.5rem 0;
  color: #856404;
}
.format-notes ul {
  margin: 0;
}
.format-notes ul li {
  color: #856404;
}

.tips-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.tip-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.tip-card h4 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}
.tip-card ul {
  margin: 0;
}
.tip-card ul li {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.troubleshooting-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.troubleshooting-list details {
  background: white;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  overflow: hidden;
}
.troubleshooting-list details summary {
  padding: 1rem;
  cursor: pointer;
  background: #f8f9fa;
  font-weight: 600;
  color: #495057;
  user-select: none;
  transition: background 0.2s ease;
}
.troubleshooting-list details summary:hover {
  background: #e9ecef;
}
.troubleshooting-list details ul {
  padding: 1rem;
  margin: 0;
  margin-left: 15px;
  background: white;
}
.troubleshooting-list details ul li {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #555;
}

.getting-started-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
}
.getting-started-card p {
  margin: 0 0 1rem 0;
  color: white;
}
.getting-started-card ol {
  text-align: left;
  max-width: 400px;
  margin: 1rem auto;
}
.getting-started-card ol li {
  color: white;
  margin-bottom: 0.5rem;
}
.getting-started-card strong {
  color: #ffd700;
}

@media (max-width: 768px) {
  .instructions-container {
    padding: 1rem;
  }
  .instructions-header h2 {
    font-size: 1.5rem;
  }
  .instructions-header p {
    font-size: 1rem;
  }
  .instruction-section {
    padding: 1rem;
  }
  .requirement-card, .tip-card {
    padding: 1rem;
  }
  .tips-grid {
    grid-template-columns: 1fr;
  }
  .code-block {
    padding: 0.75rem;
  }
  .code-block pre {
    font-size: 0.8rem;
  }
}
@media (max-width: 480px) {
  .instructions-container {
    padding: 0.5rem;
  }
  .instructions-header {
    margin-bottom: 1rem;
  }
  .instructions-header h2 {
    font-size: 1.25rem;
  }
  .instruction-section {
    padding: 0.75rem;
  }
  .getting-started-card {
    padding: 1.5rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerInstructions = class TrainerInstructions extends client_1.RWSViewComponent {
    get dataFormatExample() {
        return JSON.stringify({
            "messages": [
                {
                    "role": "system",
                    "content": "You are a helpful assistant."
                },
                {
                    "role": "user",
                    "content": "What is the capital of France?"
                },
                {
                    "role": "assistant",
                    "content": "The capital of France is Paris."
                }
            ]
        }, null, 2);
    }
    get csvFormatExample() {
        return `input,output,category
"What is machine learning?","Machine learning is a subset of artificial intelligence that enables computers to learn and improve from experience without being explicitly programmed.","AI"
"How do I bake a cake?","To bake a cake, you'll need flour, sugar, eggs, butter, and baking powder. Mix the ingredients, pour into a pan, and bake at 350°F for 25-30 minutes.","Cooking"
"What is photosynthesis?","Photosynthesis is the process by which plants use sunlight, water, and carbon dioxide to produce glucose and oxygen.","Science"`;
    }
    copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
            // Could emit an event to show a toast message
            this.emit(events_1.trainerEvents.textCopied, { text: 'Example copied to clipboard!' });
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    }
    emit(eventName, detail) {
        this.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true }));
    }
};
exports.TrainerInstructions = TrainerInstructions;
exports.TrainerInstructions = TrainerInstructions = __decorate([
    (0, client_1.RWSView)('trainer-instructions', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TrainerInstructions);
TrainerInstructions.defineComponent();
